  <template>
    <k-modal id="view-all-project-feedback-modal" :show="showModal"
      :closeOnClickAway="false"
    >
      <template #header>
        <h3>{{ modalTitle }}</h3>
      </template>
      <template #body>
        <notes-overview
          :is-project-feedback="true"
          :is-learner-support="false"
          :use-custom-notes="true"
          :custom-notes="evidenceNotes"
          custom-sort-by="note_id"
          @custom-get-notes="() => processFeedbackData(evidenceData)"
          >
          <template #tags="{ note }">
            <div class="tags">
              <span v-if="note && note.project_phase" :class="note.project_phase">{{ note.project_phase }}</span>
              <k-tooltip text="Feedback given on specific evidence" trigger-label="More information about evidence feedback" position="right">
                <i class="fas fa-info-circle" aria-hidden="true"></i>
              </k-tooltip>
            </div>
          </template>
        </notes-overview>
      </template>
    </k-modal>
  </template>

<style scoped>
  .evidence {
    color: var(--kate-type-dark);
    background-color: var(--kate-type-blue);
  }

  .evidence::before {
    --current-color: var(--kate-type-blue);

    border-color: transparent var(--current-color) transparent transparent;
  }
</style>

<script>
import KModal from '@base-components/k-modal.vue';
import { KTooltip } from '@kate/components';
import NotesOverview from '../../dashboard/student/notes-overview.vue';

export default {
  components: {
    KModal,
    NotesOverview,
    KTooltip,
  },

  props: {
    evidenceData: {
      type: Object,
      required: true,
    },

    showModal: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      evidenceNotes: [],
    };
  },

  mounted() {
    this.processFeedbackData(this.evidenceData);
  },

  computed: {
    modalTitle() {
      return this.evidenceData && this.evidenceData.name ? `${this.evidenceData.name} Feedback` : 'Evidence Feedback';
    },
  },

  methods: {
    processFeedbackData(evidenceData) {
      if (!evidenceData || evidenceData.all_feedback_text.length === 0) {
        this.evidenceNotes = [];
        return;
      }
      const evidenceFeedback = evidenceData.all_feedback_text;

      this.evidenceNotes = evidenceFeedback.map((feedbackItem, index) => ({
        note_id: evidenceFeedback.length - index, // For sorting in notes-overview, highest index = most recent
        note: feedbackItem,
        share_with_employer: false,
        source: 'project_feedback',
        project_phase: 'evidence',
      }));
    },
  },
};
</script>
